import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetCatalog, SortCatalog } from '../action-creators';
import { SORT_CATALOG } from '../actions';

export const sortCatalogEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, SortCatalog>(SORT_CATALOG),
    concatMap((action) => [new GetCatalog({ sortBy: action.sortBy })])
  );
